<template>
  <div v-if="talentList.length > 0" class="candidate-info-card-list">
    <CandidateInfoCard
      v-for="(talent) in talentList"
      :key="talent.id"
      :rowData="talent"
      :showAppliedJob="false"
      :showReferralIcon="false"
      :showSubmittedIcon="false"
      :showDuplicateCandidateIcon="false"
      :showAssessmentFit="false"
      :showResumeFit="false"
      :showAppliedDate="false"
      :showChannel="false"
      :showStatus="false"
      :isSelected="talent.selected"
      :isEmployee="talent.candidate.is_employee"
      :isAlumni="talent.candidate.is_alumni"
      :isAgencyUploadedAndHid="talent.is_agency_uploaded_and_hid"
      :joinDate="talent.join_time"
      :candidateId="talent.candidate.id"
      :candidateName="talent.candidate.name"
      :location="getLocationInfo(talent.candidate.location)"
      :avatar="talent.candidate.avatar"
      :gender="talent.candidate.gender"
      :maxDegree="talent.candidate.maxDegreeI18nName"
      :age="talent.candidate.age"
      :email="talent.candidate.email"
      :phone="talent.candidate.mobile || talent.candidate.second_phone"
      :duplicateCandidateList="talent.duplicate_candidate_list"
      :workList="talent.resume.work_list"
      :internList="talent.resume.intern_list"
      :educationList="talent.resume.education_list"
      :operationList="operationList"
      :tagList="talent.tag_list"
      @avatarClick="onCandidateAvatarClick(talent)"
      @candidateNameClick="onCandidateNameClick(talent)"
      @statusClick="onCandidateStatusClick(talent)"
      @selectChange="onSelectChange(talent, $event)"
      @handleOperation="handleOperation(talent, $event)"
    ></CandidateInfoCard>
  </div>
  <div v-else class="no-data">{{ $t('common.label.noData') }}</div>
</template>

<script>
import listMixin from '../listMixin'
import CandidateInfoCard from '../components/candidateInfoCard.vue'
import _ from 'lodash'
import { addI18nProperty, getConstantI18nValue, getI18nPropertyValue } from '@/i18n'
import { DEGREE } from '@/constant/meta'

export default {
  mixins: [listMixin],
  components: {
    CandidateInfoCard
  },
  data () {
    return {
      talentList: [],
      talentIds: []
    }
  },
  computed: {
    listEl () {
      return this.$el
    },
    selectedList () {
      return _.filter(this.talentList, talent => talent.selected)
    },
    hasAssessmentPermission () {
      return this.hasAnyPermission('PREMIUM_ASSESSMENTS')
    },
    hasDuplicateCandidatePermission () {
      return this.hasAnyPermission('PREMIUM_DUPLICATE_CANDIDATE')
    }
  },
  created () {

  },
  methods: {
    handleOperation (candidate, operation) {
      operation.operator(candidate)
    },
    refreshListData (data, oldData) {
      if (data !== oldData) {
        this.talentIds = []
        this.talentList = []
      }
      _.forEach(data, talent => {
        if (this.talentIds.includes(talent.id)) {
          return
        }
        this.talentIds.push(talent.id)
        talent.candidate.avatar = talent.is_agency_uploaded_and_hid ? this.$DjangoStaticUrl('images_en/default.jpg') : this.$DjangoBaseUrl(talent.candidate.photo)
        talent.candidate.email = talent.is_agency_uploaded_and_hid ? '***' : talent.candidate.email
        talent.candidate.mobile = talent.is_agency_uploaded_and_hid ? '***' : talent.candidate.mobile
        talent.candidate.second_phone = talent.is_agency_uploaded_and_hid ? '***' : talent.candidate.second_phone
        _.forEach(talent.resume.work_list, this.formatWorkInfo)
        _.forEach(talent.resume.intern_list, this.formatWorkInfo)
        _.forEach(talent.resume.education_list, this.formatEducationInfo)
        this.talentList.push(talent)
      })
    },
    formatWorkInfo (work) {
      work.company = work.company_name
      work.job = work.job_title
      work.startDate = work.start_date
      work.endDate = work.end_date
    },
    formatEducationInfo (education) {
      if (!education.degree) {
        Object.defineProperty(education, 'degree', {
          configurable: true,
          enumerable: true,
          get () {
            return getConstantI18nValue(DEGREE, education.degree_level, 'meta.DEGREE')
          }
        })
      }
      addI18nProperty(education, 'school', 'school_cn_name', 'school_en_name')
      addI18nProperty(education, 'major', 'major_cn_name', 'major_en_name')
      education.startDate = education.start_date
      education.endDate = education.end_date
    },
    getLocationInfo (location) {
      if (!location) {
        return
      }
      const city = location.city
      const province = location.province
      const country = location.country
      return getI18nPropertyValue(city || province || country, 'cn_name', 'name')
    },
    onCandidateStatusClick (talent) {
      this.emitCandidateStatusClickEvent(talent)
    },
    onCandidateNameClick (talent) {
      this.emitOpenDetailEvent(talent)
    },
    onCandidateAvatarClick (talent) {
      this.emitOpenDetailEvent(talent)
    },
    onSelectChange (talent, selected) {
      talent.selected = selected
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (val, oldVal) {
        this.refreshListData(val, oldVal)
      }
    },
    selectedList: {
      handler () {
        this.emitSelectedChangeEvent(this.selectedList)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-info-card-list {
  height: 100%;
  padding-top: 10px;
  overflow: auto;

  .candidate-info-card {
    margin-top: 14px;

    &:first-child {
      margin-top: 0;
    }
  }
}
.no-data {
  line-height: 60px;
  width: 50%;
  color: #909399;
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>
